module.exports = __webpack_public_path__ + "src/app/_content/imgs/motorrad/warranty/five-year-warranty.jpg?3b33f8dc347f1a1a95b8f16306fd3302";